import { Helmet, HelmetData } from "react-helmet-async";
import { AI_BG_NEW } from "../../../assets";
import Select from "react-select";
import { useEffect, useState } from "react";
import JobDetailsModal from "../careers/JobDetailsModal";
import { toast } from "react-hot-toast";
import ArrowOutwardOutlinedIcon from "@mui/icons-material/ArrowOutwardOutlined";

const helmetData = new HelmetData({});

const teams = [
  { value: "Devs", label: "Devs" },
  { value: "Marketing", label: "Marketing" },
  { value: "Product", label: "Product" },
  { value: "Sales", label: "Sales" },
];
const jobLocation = [
  { value: "remote", label: "Remote" },
  { value: "usa", label: "USA" },
  { value: "lagos", label: "Lagos, Nigeria" },
  { value: "london", label: "London, UK" },
];

function CareersPage() {
  const [showModal, setShowModal] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [title, setTitle] = useState("");
  const [team, setTeam] = useState("");
  const [location, setLocation] = useState("");
  const [titleError, setTitleError] = useState(false);
  const [teamError, setTeamError] = useState(false);
  const [locationError, setLocationError] = useState(false);
  const [data, setData] = useState([]);
  const [jobTitles, setJobTitles] = useState([]);

  useEffect(() => {
    fetch(`https://cms.analyticsintelligence.ai/api/job-lists`)
        .then((res) => res.json())
        .then((jobs) => {
          setData(jobs.data);
          const titles = jobs.data.map((t) => ({
            value: t.title,
            label: t.title,
          }));
          setJobTitles(titles);
        });
  }, []);

  useEffect(() => {
    let filteredResult = [];
    let formattedTitle = "";
    // This check is to handle and correctly format user input before filtering the search
    if (title) {
      const words = title.split(" ");
      const formattedWords = words.map((w) => {
        if (w !== "") return w[0].toUpperCase() + w.substring(1).toLowerCase();
        return null;
      });
      formattedTitle = formattedWords.join(" ");
    }
    if (title && !team && !location) {
      filteredResult =
        data && data.filter((data) => data.title.includes(formattedTitle));
      setSearchData(filteredResult);
    } else if (location && !title && !team) {
      filteredResult =
        data && data.filter((data) => data.location === location);
      setSearchData(filteredResult);
    } else if (team && !location && !title) {
      filteredResult = data && data.filter((data) => data.team === team);
      setSearchData(filteredResult);
    } else if (location && title && !team) {
      filteredResult =
        data &&
        data.filter(
          (data) =>
            data.location === location && data.title.includes(formattedTitle)
        );
      setSearchData(filteredResult);
    } else if (location && !title && team) {
      filteredResult =
        data &&
        data.filter((data) => data.location === location && data.team === team);
      setSearchData(filteredResult);
    } else if (!location && title && team) {
      filteredResult =
        data &&
        data.filter(
          (data) => data.team === team && data.title.includes(formattedTitle)
        );
      setSearchData(filteredResult);
    } else if (location && title && team) {
      filteredResult =
        data &&
        data.filter(
          (data) =>
            data.team === team &&
            data.title.includes(formattedTitle) &&
            data.location === location
        );
      setSearchData(filteredResult);
    } else {
      setSearchData([]);
    }
  }, [title, team, location, data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!title) {
      setTitleError(true);
    } else {
      setTitleError(false);
    }
    if (!team) {
      setTeamError(true);
    } else {
      setTeamError(false);
    }
    if (!location) {
      setLocationError(true);
    } else {
      setLocationError(false);
    }
    if (title && team && location) {
      setTitleError(false);
      setTeamError(false);
      setLocationError(false);
      // This check is to handle and correctly format user input before filtering the search
      const words = title.split(" ");
      const formattedWords = words.map((w) => {
        if (w !== "") return w[0].toUpperCase() + w.substring(1).toLowerCase();
        return null;
      });
      const formattedTitle = formattedWords.join(" ");

      const searchResult =
        data &&
        data.filter(
          (data) =>
            data.title.includes(formattedTitle) &&
            data.team === team &&
            data.location === location
        );
      if (searchResult.length === 0) {
        toast.error("No job available for this search entries", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: "colored",
        });
      }
      setSearchData(searchResult);
    }
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const handleShowModal = (id) => {
    setShowModal(true);
    scrollToTop();
    const filtered = data && data.filter((data) => data.id === id);
    console.log("filtered", filtered)
    setFilteredData(filtered);
  };
  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <Helmet helmetData={helmetData}>
        <title>Careers at Analytics Intelligence Ltd | Global AI &amp; Analytics Jobs</title>
        <link rel="canonical" href="https://analyticsintelligence.com/careers" />
        <meta
          name="description"
          content="Join Analytics Intelligence Ltd — a global AI and analytics company. Explore roles across engineering, product, marketing, and sales, remote or in the USA, London, and Lagos."
        />
        <meta
          name="keywords"
          content="Analytics Intelligence jobs, Analytics Intelligence Ltd careers, global AI careers, enterprise AI jobs, AI research jobs, engineering roles in AI, careers in artificial intelligence, data analytics careers Africa, fintech AI solutions Mauritius careers, work in AI Africa, AI company in Mauritius jobs, data analytics company in Africa careers"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Analytics Intelligence Ltd" />
        <meta property="og:title" content="Careers at Analytics Intelligence Ltd | Global AI & Analytics Jobs" />
        <meta property="og:description" content="Join Analytics Intelligence Ltd — a global AI and analytics company. Explore roles across engineering, product, marketing, and sales, remote or in the USA, London, and Lagos." />
        <meta property="og:url" content="https://analyticsintelligence.com/careers" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://analyticsintelligence.com/favicon.png" />
        <meta property="og:site_name" content="Analytics Intelligence" />
        <meta property="og:locale" content="en_GB" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@_AnalyticsIntel" />
        <meta name="twitter:title" content="Careers at Analytics Intelligence Ltd | Global AI & Analytics Jobs" />
        <meta name="twitter:description" content="Join Analytics Intelligence Ltd — a global AI and analytics company. Explore roles across engineering, product, marketing, and sales, remote or in the USA, London, and Lagos." />
        <meta name="twitter:image" content="https://analyticsintelligence.com/favicon.png" />
      </Helmet>
      <main>
        {showModal && (
          <div className="fixed top-0 left-0 z-20 bg-black/80 w-full h-full"></div>
        )}
        <section
          style={{
            backgroundImage: `url("${AI_BG_NEW}")`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          className="min-h-[65vh] flex items-center"
        >
          <div className="container mx-auto w-full h-full pt-[126px] md:pt-[96px] pb-[0px]">
            <div className="flex flex-col items-center gap-4">
              <h2 className="text-[38px] md:text-[48px] text-center md:text-left font-extrabold leading-[1.3] md:leading-[54px] text-white">
                Careers
              </h2>

              <p className="text-sm md:text-lg text-center font-medium text-[#E3E3E3] leading-5 max-w-[1200px]">
                Join us in shaping the future of AI in analytics.
                <br /> We are always looking for talented individuals passionate
                about data, AI, and enterprise transformation. Explore
                opportunities across engineering, research, customer success,
                and business development — and help us build solutions that
                matter.
              </p>
            </div>
          </div>
        </section>

        <div className="flex items-center justify-center pb-[60px]">
          <div className="flex flex-col items-center mt-[60px] text-blue max-w-[1300px] w-[90%] max-auto gap-[60px]">
            <form
              className="flex flex-col  md:flex-row gap-[28px] rounded-[20px] shadow-box py-[28px] px-[23px] w-full text-black"
              onSubmit={handleSubmit}
            >
              <label className="relative md:w-[30%] w-full">
                <Select
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      paddingLeft: "40px",
                      paddingTop: "4px",
                      paddingBottom: "4px",
                      borderRadius: "10px",
                      borderColor: titleError ? "red" : "#C4C4C4",
                      width: "100%",
                    }),
                  }}
                  options={jobTitles}
                  placeholder="Title"
                  onChange={(e) => setTitle(e.label)}
                />
                <img
                  className="absolute left-[15px] top-[30%]"
                  src="https://res.cloudinary.com/analytics-intelligence/image/upload/v1678175310/Vector_14_tvwqv6.svg"
                  alt="search-icon"
                />
              </label>
              <label className="relative md:w-[30%] w-full">
                <Select
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      paddingLeft: "40px",
                      paddingTop: "4px",
                      paddingBottom: "4px",
                      borderRadius: "10px",
                      borderColor: teamError ? "red" : "#C4C4C4",
                      width: "100%",
                    }),
                  }}
                  options={teams}
                  placeholder="Team"
                  onChange={(e) => setTeam(e.label)}
                />
                <img
                  className="absolute left-[15px] top-[20%]"
                  src="https://res.cloudinary.com/analytics-intelligence/image/upload/v1678175318/Vector_15_gp5d9l.svg"
                  alt="briefcase-icon"
                />
              </label>
              <label className="relative md:w-[30%] w-full">
                <Select
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      paddingLeft: "40px",
                      paddingTop: "4px",
                      paddingBottom: "4px",
                      borderRadius: "10px",
                      borderColor: locationError ? "red" : "#C4C4C4",
                      width: "100%",
                    }),
                  }}
                  options={jobLocation}
                  placeholder="Location"
                  onChange={(e) => setLocation(e.label)}
                />
                <img
                  className="absolute left-[15px] top-[20%]"
                  src="https://res.cloudinary.com/analytics-intelligence/image/upload/v1678175327/Vector_16_uo268c.svg"
                  alt="location-icon"
                />
              </label>
              <button className="bg-blue py-[10px] md:w-[10%] w-full rounded-[10px] text-black font-[500] btn-sweep btn-sweep-blue">
                Search
              </button>
            </form>
            <div className="flex flex-col gap-[50px] w-full">
              {searchData.length === 0 &&
                data &&
                data.map((job) => (
                  <div
                    key={job.id}
                    className="px-3 md:px-6 py-3 border border-[#FFFFFF3B] rounded-xl flex gap-12 items-start"
                  >
                    <div className="flex flex-col w-[90%] gap-1">
                      <h2 className="text-base md:text-lg font-bold text-white">
                        {job.attributes.title}
                      </h2>

                      <div className="space-y-1">
                        <p className="text-[#C0C0C0] text-sm leading-[150%]">
                          {job.attributes.summary}
                        </p>
                        <p className="text-white font-bold text-sm leading-[150%]">
                          {job.attributes.location}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start justify-end gap-2 w-[10%]">
                      <p
                        className="text-white text-sm font-semibold w-fit"
                        onClick={() => handleShowModal(job.id)}
                      >
                        Apply Now
                      </p>
                      <ArrowOutwardOutlinedIcon
                        className="text-white"
                        fontSize="small"
                      />
                    </div>
                  </div>
                ))}
              {searchData.length > 0 &&
                searchData.map((job) => (
                  <div
                    key={job.id}
                    className="px-3 md:px-6 py-3 border border-[#FFFFFF3B] rounded-xl flex gap-12 items-start"
                  >
                    <div className="flex flex-col w-[90%] gap-1">
                      <h2 className="text-base md:text-lg font-bold text-white">
                        {job.attributes.title}
                      </h2>

                      <div className="space-y-1">
                        <p className="text-[#C0C0C0] text-sm leading-[150%]">
                          {job.attributes.summary}
                        </p>
                        <p className="text-white font-bold text-sm leading-[150%]">
                          {job.attributes.location}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start justify-end gap-2 w-[10%]">
                      <p
                        className="text-white text-sm font-semibold w-fit"
                        onClick={() => handleShowModal(job.id)}
                      >
                        Apply Now
                      </p>
                      <ArrowOutwardOutlinedIcon
                        className="text-white"
                        fontSize="small"
                      />
                    </div>
                  </div>
                ))}
            </div>
            {showModal && (
              <JobDetailsModal data={filteredData} close={handleClose} />
            )}
          </div>
        </div>
        <style jsx="true">
          {`
            .shadow-box {
              box-shadow: 0px 0px 32px rgba(0, 0, 0, 0.05);
            }
          `}
        </style>
      </main>
    </>
  );
}

export default CareersPage;
